import ArrowRightTwoIcon from "@assets/icons/arrowRightTwo"
import NotesBackgroundIcon from "@assets/icons/notesBackground"
import { Button } from "@components/Button"

const Notes = ({
  setAppointmentStage,
  setAppointmentDetails,
  appointmentDetails,
}) => {
  return (
    <div className="relative rounded-2xl sm:bg-[--pure-white] flex justify-center sm:justify-normal overflow-hidden h-max xl:h-[30rem]">
      <div className="absolute bottom-0 right-0 z-[1] hidden xl:block">
        <NotesBackgroundIcon />
      </div>
      <div className="flex flex-col gap-2 rounded-2xl bg-[--pure-white] sm:bg-[transparent] pb-4 px-4 sm:py-8 sm:px-10 h-full z-10 overflow-y-scroll no-scrollbar w-full max-w-[56.5rem]">
        <div className="flex flex-col gap-2">
          <div>Notes</div>
          <textarea
            value={appointmentDetails.note}
            onChange={(event) => {
              const value = event.currentTarget.value
              setAppointmentDetails((previous) => {
                return { ...previous, note: value }
              })
            }}
            type="text"
            className="h-[12.5rem] w-full max-w-4xl border border-[#C4E2FF] py-2 px-3 rounded-lg"
          ></textarea>
          <div className="text-xs">
            This is only for your reference, Patient will not be able to access
            it.
          </div>
        </div>

        <div className="flex gap-2 mt-10 rounded-3xl bg-[--pure-white] max-w-[22.5rem]">
          <button
            onClick={() => {
              setAppointmentDetails((previous) => {
                return { ...previous, note: "" }
              })
              setAppointmentStage(3)
            }}
            className="flex items-center gap-2 border border-[--primary-blue] text-[--primary-blue] p-2 text-sm font-bold rounded-lg"
          >
            SKIP <ArrowRightTwoIcon />
          </button>
          <Button
            disabled={appointmentDetails.note === ""}
            onClick={() => {
              setAppointmentStage(3)
            }}
            className="!grow !font-bold"
          >
            SAVE AND NEXT
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Notes
